import { motion } from "framer-motion";
import { useLanguage } from "../../i18n/LanguageContext";

export default function Manifeste() {
  const { t } = useLanguage();
  return (
    <section
      id="manifeste"
      data-testid="manifeste-section"
      className="relative py-32 md:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-20">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
            className="md:col-span-4"
          >
            <div className="flex items-center gap-4">
              <span className="h-px w-10 bg-[#C5A059]" />
              <span className="tcp-eyebrow">{t.manifeste.eyebrow}</span>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="md:col-span-8 md:pt-4"
          >
            <p className="font-display text-[#F5F5F0]/90 text-2xl md:text-3xl leading-[1.4]">
              {t.manifeste.body.before}
              <span className="text-[#C5A059] italic">
                {t.manifeste.body.accent}
              </span>
              {t.manifeste.body.after}
            </p>

            <div className="mt-14 grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
              {t.manifeste.pillars.map((it) => (
                <div key={it.k} className="border-t border-white/10 pt-5">
                  <div className="text-[11px] tracking-[0.3em] uppercase text-[#C5A059]">
                    {it.k}
                  </div>
                  <div className="mt-2 font-display text-xl text-[#F5F5F0]">
                    {it.v}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
